import React from 'react';

interface Props {
	size: number;
}

export const ArtDesignIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>artDesign</title>
		<g>
			<path d='M12.42 23.69a2.9 2.9 0 01-2.9-2.9v-4a6.81 6.81 0 119.65-6.22 6.8 6.8 0 01-3.85 6.1v4.16a2.9 2.9 0 01-2.9 2.86zM12.29 4.6a6 6 0 00-6 5.93 5.88 5.88 0 003.84 5.53l.27.11v4.62a2 2 0 104.08 0v-4.72l.26-.11A5.92 5.92 0 0012.29 4.6z' />
			<path d='M14.61 18.27H10a.43.43 0 010-.86h4.64a.43.43 0 110 .86zM14.61 19.82H10a.43.43 0 010-.82h4.64a.43.43 0 010 .86zM8.93 12.34a.43.43 0 01-.31-.14c-.7-.75-1.28-2 0-3.71a.43.43 0 01.6-.09.42.42 0 01.1.6c-1 1.34-.49 2.13 0 2.61a.43.43 0 010 .61.44.44 0 01-.39.12zM11.77 3.42a.43.43 0 01-.43-.42V.74a.43.43 0 01.86 0V3a.43.43 0 01-.43.42zM18.22 6a.44.44 0 01-.32-.72l1.5-1.72a.43.43 0 01.65.57l-1.51 1.72a.41.41 0 01-.32.15zM22.29 11h-2.52a.43.43 0 110-.86h2.52a.43.43 0 010 .86zM4.23 11H1.71a.43.43 0 010-.86h2.52a.43.43 0 010 .86zM5.84 6a.44.44 0 01-.33-.15L4 4.13a.43.43 0 010-.61.44.44 0 01.61 0l1.5 1.72a.44.44 0 01-.27.76zM19.72 17.3a.41.41 0 01-.32-.15l-1.5-1.72a.43.43 0 11.64-.56l1.51 1.71a.44.44 0 010 .61.48.48 0 01-.33.11zM4.33 17.3a.44.44 0 01-.33-.72l1.5-1.71a.43.43 0 01.61 0 .42.42 0 010 .6l-1.5 1.72a.44.44 0 01-.28.11z' />
		</g>
	</svg>
);
